<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="width"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="基金经理姓名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['managerName', validatorRules.managerName]"
            placeholder="请输入基金经理姓名"
          ></a-input>
        </a-form-item>

        <a-form-item label="职位" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['duty', validatorRules.duty]"
            placeholder="请输入职位"
          ></a-input>
        </a-form-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="上传头像："
          prop="bigPicurl"
        >
          <!-- <j-image-upload
            v-decorator="['headUrl']"
            class="avatar-uploader"
            file-type="file"
            fileKey="file"
            url="system-file-biz/resources/upload"
            text="上传"
            @getFileList="getFileList"
          ></j-image-upload> -->
          <UploadImage
            @handleFileList="(url) => getFileList(url)"
            v-decorator="['headUrl']"
            :imgUrl="bigImgUrl"
          />
        </a-form-model-item>
        <a-form-item
          label="个人简介"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :max-length="300"
            v-decorator="[
              'managerIntroduction',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入公司简介',
                  },
                ],
              },
            ]"
            rows="4"
            placeholder="请输入推送标题"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import JImageUpload from '@/components/jeecg/JImageUpload';
import { saveManager } from '@/api/investment';
import UploadImage from '@/components/common/UploadImage';
export default {
  name: 'ProductsFundManagerModal',
  components: {
    JDictSelectTag,
    JImageUpload,
    UploadImage,
  },
  data() {
    return {
      id: '', //经理id
      form: this.$form.createForm(this),
      title: '新增',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        duty: {
          rules: [{ required: true, message: '请输入职位!' }],
        },
        managerName: {
          rules: [{ required: true, message: '请输入基金经理姓名!' }],
        },
        mobile: {
          rules: [
            { required: true, message: '请输入电话号码!' },
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码!' },
          ],
        },
        email: {
          rules: [
            {
              pattern: /^([\w]+\.*)([\w]+)@[\w]+\.\w{3}(\.\w{2}|)$/,
              message: '请输入正确的电子邮件!',
            },
          ],
        },
      },
      loading: false,
      fileList: [],
      bigImgUrl: '',
    };
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      console.warn(record);
      this.id = record.id;
      this.form.resetFields();
      this.model = {};
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'managerName',
            'managerIntroduction',
            'duty',
            'headUrl'
          )
        );
        this.fileList.fileName = this.model.headUrl;
        this.bigImgUrl = this.model.previewUrl ? this.model.previewUrl : '';
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      console.log(this.model);
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          console.warn(values);
          let formData = {};
          let id = {
            id: this.id,
          };

          if (this.title == '编辑') {
            formData = Object.assign(id, values);
          } else {
            formData = Object.assign(values);
          }
          formData.headUrl = this.fileList.fileName;
          saveManager(formData).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
            that.confirmLoading = false;
            that.close();
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    getFileList(file) {
      this.fileList = file;
      if (Array.isArray(file)) {
        this.bigImgUrl = this.fileList[0].fileUrl;
      } else {
        this.bigImgUrl = this.fileList.fileUrl;
      }
    },
  },
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
